export default __webpack_public_path__ + "static/media/logo-main.e5e4edcb.svg";